import { IFamilyMember } from "@app-types/websocket/family.types";
import { Dialog, DialogContent, DialogTitle, DialogActions, DialogContentText } from "@material-ui/core";
import Button from "@components/common/button/Button";
import TranslateNew from "@translate/TranslateNew";
import * as React from "react";
import { connect } from "react-redux";
import { IEditEvent, IEditEventVisibility, IEvent } from "@app-types/websocket/event.types";
import * as EventActions from '@services/events/event.action';

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps {
  family: IFamilyMember[];
  importantViewerId: number | null;
  addViewerToEvent: (data: IEditEventVisibility) => void;
  onClose: () => void;
  events:IEvent[];
}

class ShareEventDialog extends React.Component<IProps> {
  public render() {
    const { importantViewerId, family, events } = this.props;
    const viewer = family.find((member) => member.id === importantViewerId);
    const viewerName = viewer?.firstName;

    const eventsToUpdate: number[] = [];
    if (importantViewerId !== undefined) {
      const today = Date.now();
      events.forEach((event) => {
          if (event.endTime >= today) {
              eventsToUpdate.push(event.id); 
          }
      });
    }


    return (
      <Dialog open={importantViewerId !== null && eventsToUpdate.length > 0} onClose={this.props.onClose}>
           <DialogTitle>{tn.lang.shareFutureEvents}</DialogTitle>
        <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            <DialogContentText>{tn.lang.shareEventWithImportantAdult}{viewerName}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>{tn.lang.no}</Button>
          <Button variant="contained" color="primary"onClick={this.handleAddEventsAndClose}>{tn.lang.okay}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  private handleAddEventsAndClose = () => {
    this.handleAddViewerToEvents()
    this.props.onClose()
  }

  private handleAddViewerToEvents = () => {
    const {importantViewerId, events} = this.props;
    
    if (importantViewerId === null){
        return;
    }

    const eventsToUpdate: number[] = [];
    const today = Date.now();

    events.forEach((event) => {
        if (event.endTime >= today) {
            eventsToUpdate.push(event.id); 
        }
    });
    
    const eventVisibility: IEditEventVisibility = {
        viewerUserId: importantViewerId,  
        events: eventsToUpdate 
    };
    this.props.addViewerToEvent(eventVisibility)
}
}


const mapStateToProps = (state: any) => ({
    family: state.family.family, 
    events: state.event.events,
  });


  const mapDispatchToProps = {
    addViewerToEvent: EventActions.addViewerToEvent
  };

export default connect(mapStateToProps,mapDispatchToProps)(ShareEventDialog);



// WEBPACK FOOTER //
// ./src/components/settings/share-events.component.tsx